module.exports = __webpack_public_path__ + "img/ren.ddc0da88.jpeg";